// Logo asset paths only. Brand colors are no longer hardcoded — the theme
// system uses MUI's default color palettes and lets the user pick one at
// runtime (see ThemeContext.tsx).

export const logos = {
  // Header + login — tagline'lı tam logo (kullanımda olan birincil logo).
  fullLight:     "/brand/zekabin-logo-light.png",
  fullDark:      "/brand/zekabin-logo-dark.png",
  // Sade wordmark (simge + Zekabin, tagline'sız) — şu an kullanılmıyor, dar başlıklar için hazır.
  wordmarkLight: "/brand/zekabin-wordmark-light.png",
  wordmarkDark:  "/brand/zekabin-wordmark-dark.png",
  // Yuvarlak köşeli rozet simgesi (şeffaf zemin).
  mark:          "/brand/zekabin-mark.png",
};

export type ThemeMode = "light" | "dark";
